import React from 'react';
import { Modal } from 'antd';
import dayjs from 'dayjs';
import commonS from 'styles/common.module.less';
import { Event } from 'types/calendar';
import s from './s.module.less';
import { EServiceType, KlarityService, Prospect } from 'types/common';
// eslint-disable-next-line import/no-cycle
import Content from '../index';

type Props = {
    onCancel: () => void;
    event?: Event; //for edit fun
    onSuccess?: (serviceType?: EServiceType) => void;
    currentChannelId?: number;
    prospect?: Prospect;
    defaultStart?: dayjs.Dayjs;
    defaultEnd?: dayjs.Dayjs;
    timezone?: string;
    allSpecialityData?: KlarityService[];
    hideAddBlock?: boolean;
    targetServiceType?: EServiceType;
    targetClientId?: number;
    targetProviderId?: number;
    recurrenceSeriesId?: number; // edit existing prescription recurrence series
    editingTextVisitId?: number; // edit existing one-time prescription refill (Starts on only)
    editingTextVisitData?: {
        clientId?: number;
        specialty?: string;
        startAt?: string;
    };
    isGroupPractice?: boolean;
};

const AddAndEditCalendarEventModal = (props: Props) => {
    const {
        onCancel,
        event,
        onSuccess,
        defaultStart,
        defaultEnd,
        timezone,
        allSpecialityData,
        hideAddBlock,
        targetServiceType,
        targetClientId,
        recurrenceSeriesId,
        editingTextVisitId,
        editingTextVisitData,
        isGroupPractice,
        targetProviderId,
    } = props;
    return (
        <Modal
            closable
            className={commonS.modalFixHeightMaxWrap}
            width="600px"
            destroyOnClose
            onCancel={onCancel}
            okText="Save"
            open
            wrapClassName={s.modalWrap}
            closeIcon={
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M6 18L18 6M6 6L18 18"
                        stroke="#9CA3AF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            }
            footer={null}
        >
            <Content
                event={event}
                onCancel={onCancel}
                onSuccess={onSuccess}
                defaultStart={defaultStart}
                defaultEnd={defaultEnd}
                timezone={timezone}
                allSpecialityData={allSpecialityData}
                hideAddBlock={hideAddBlock}
                targetServiceType={targetServiceType}
                targetClientId={targetClientId}
                recurrenceSeriesId={recurrenceSeriesId}
                editingTextVisitId={editingTextVisitId}
                editingTextVisitData={editingTextVisitData}
                isGroupPractice={isGroupPractice}
                targetProviderId={targetProviderId}
            />
        </Modal>
    );
};

export default AddAndEditCalendarEventModal;
